import { render, staticRenderFns } from "./docDialog.vue?vue&type=template&id=628fee14&scoped=true&"
import script from "./docDialog.vue?vue&type=script&lang=js&"
export * from "./docDialog.vue?vue&type=script&lang=js&"
import style0 from "./docDialog.vue?vue&type=style&index=0&id=628fee14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fee14",
  null
  
)

export default component.exports